import { useLayoutEffect, useState } from "react";

const useResponsiveSize = () => {
  const [size, setSize] = useState<"small" | "middle" | "large">("large");

  useLayoutEffect(() => {
    const updateSize = () => {
      if (window.innerWidth < 640) {
        setSize("middle"); // tablet
      } else {
        setSize("large"); // desktop
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
};
export default useResponsiveSize;
